import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './pages/Hero';
import TechStack from './pages/TechStack';
import Projects from './pages/Projects';
import Footer from './components/Footer';
// import About from './pages/About';
import './App.css';
import Experience from './pages/Experience';
import Contact from './pages/Contact';
import BottomDockNavbar from './components/BottomDockNavbar';
import Existence from './pages/Existence';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <BottomDockNavbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <TechStack />
                <Existence />
                <Projects />
                {/* <About /> */}
                <Experience />
                <Contact />
              </>
            } />
            <Route path="/projects" element={<Projects />} />
            {/* <Route path="/about" element={<About />} /> */}
            <Route path="/experience" element={<Experience />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/techstack" element={<TechStack />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;